export const LANGUAGES_URL = '/account/preferred-languages/';
